<template>
  <div class="common-footer" :class="customFooterNavigation && 'custom-footer'" :style="customStyle">
    <template v-if="customFooterNavigation">
      <div v-for="(navigationList, index) in customFooterNavigation" class="custom-navigation" :key="index">
        <div v-for="(item, index) in navigationList" class="navigation-item" :key="index">
          <div class="content">
            <a v-if="item.link" class="link" @click="handleLinkClick(item.link)">{{ item.label }}</a>
            <span class="label" v-else>{{ item.label }}</span>
          </div>
          <el-divider v-if="index < navigationList.length - 1" direction="vertical"></el-divider>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="copyright">
        <span>Copyright © 2012~{{ new Date()|formatDateTime('YYYY') }} AJINGA Inc.  All rights reserved.</span>
        <a v-if="showFooterLink" class="link" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102007425">
            <img src="@/assets/image/gateway_record.png"/>沪公网安备 31010102007425号
        </a>
        <a v-if="showFooterLink" class="link" target="_blank" href="http://beian.miit.gov.cn">沪ICP备10033189号</a>
        <a v-if="showFooterLink" class="link" target="_blank" href="http://beian.miit.gov.cn">沪B2-20140087</a>
      </div>
      <div v-if="showFooterLink" class="navigation">
        <div>
          <a class="link" href="/">{{ $t('admin.layout.footer.home') }}</a>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div>
          <a class="link" href="/aboutus/">{{ $t('admin.layout.footer.aboutUs') }}</a>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div>
          <a class="link" href="/contactus/">{{ $t('admin.layout.footer.contactUs') }}</a>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div>
          <a class="link" href="/tos/">{{ $t('login.common.message.policy.userAgreement') }}</a>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div>
          <a class="link" href="/policy/">{{ $t('login.common.message.policy.privacyPolicy') }}</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { emailRegexp } from '@/utils/validator'

export default {
  props: {
    showFooterLink: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('company', ['companyThemeSetting']),
    customFooterNavigation () {
      const footerContent = this.companyThemeSetting?.footerSetting?.footerContent
      if (footerContent && footerContent.length > 0) {
        return footerContent
      }
      return null
    },
    customStyle () {
      return {
        '--footer-background-color': this.companyThemeSetting?.footerSetting?.footerBackgroundColor,
        '--footer-color': this.companyThemeSetting?.footerSetting?.footerFontColor,
        '--footer-height': this.companyThemeSetting?.footerSetting?.footerHeight ? `${this.companyThemeSetting?.footerSetting?.footerHeight}px` : '66px'
      }
    }
  },
  created () {

  },
  methods: {
    handleLinkClick (link) {
      if (emailRegexp.test(link)) {
        window.location.href = `mailto:${link}`
      } else {
        window.location.href = link
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-footer {
  display: flex;
  height: 40px;
  margin: 25px auto 0;
  font-size: 12px;
  justify-content: center;
  width: 1320px;

  .copyright {
    margin-left: 10px;
    color: #666666;

    span {
      margin-right: 3px;
    }

    a {
      margin-right: 7px;

      img {
        width: 12px;
        height: 12px;
        vertical-align: -1px;
      }
    }
  }

  .navigation {
    display: flex;
    margin-right: 0;
    text-align: center;
    align-items: center;

    & > div {
      margin: 0 8px;
      vertical-align: middle;

      a {
        height: 18px;
        line-height: 18px;
      }
    }
  }

  &.custom-footer {
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: var(--footer-height, 66px);
    display: flex;
    background-color: var(--footer-background-color, #f7f7f7);

    .custom-navigation {
      display: flex;
      align-items: center;

      .navigation-item {
        display: flex;
        align-items: center;

        .content {
          .link {
            color: var(--footer-color, #909399);
            transition: color 0.3s;

            &:hover {
              color: var(--custom-color, #0096cc);
            }
          }

          .label {
            color: var(--footer-color, #909399);
          }
        }
      }
    }
  }

}
</style>
